module.exports = __webpack_public_path__ + "img/live2.85ba7e4f.png";